import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assests/logo/havbit 6.png";
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&family=Inter:wght@300;400;500&display=swap');

  :root {
    --red: #D0021B;
    --red-dark: #A80016;
    --black: #111111;
    --ink: #1A1A1A;
    --white: #FFFFFF;
    --off-white: #F7F7F7;
    --light-grey: #F0F0F0;
    --mid-grey: #E0E0E0;
    --text-grey: #666666;
    --text-light: #999999;
  }

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; }
  body { font-family: 'Inter', sans-serif; background: var(--white); color: var(--ink); overflow-x: hidden; }

  /* ─── HEADER / NAV ─── */
  .hv-header {
    position: fixed; top: 0; left: 0; right: 0; z-index: 100;
    background: rgba(255,255,255,0.96); backdrop-filter: blur(12px);
    border-bottom: 1px solid var(--mid-grey);
  }
  .hv-nav {
    display: flex; align-items: center; justify-content: space-between;
    padding: 0 4rem; height: 90px;
  }
  .hv-nav-logo { display: flex; align-items: center; }
  .hv-nav-logo img { height: 100px; display: block; }
  .hv-nav-logo-text { font-family: 'Syne', sans-serif; font-size: 1.5rem; font-weight: 800; color: #111; }
  .hv-nav-logo-text span { color: #D0021B; }
  .hv-nav-links { display: flex; gap: 2.5rem; list-style: none; }
  .hv-nav-links a {
    text-decoration: none; font-size: 0.78rem; font-weight: 500;
    color: var(--text-grey); letter-spacing: 0.06em; text-transform: uppercase; transition: color 0.2s;
  }
  .hv-nav-links a:hover { color: var(--red); }
  .hv-nav-cta {
    background: var(--red) !important; color: var(--white) !important;
    padding: 0.45rem 1.2rem; border-radius: 2px; font-size: 0.75rem !important;
  }
  .hv-nav-cta:hover { background: var(--red-dark) !important; }

  /* Hamburger */
  .hv-hamburger {
    display: none; flex-direction: column; gap: 5px; cursor: pointer;
    background: none; border: none; padding: 4px;
  }
  .hv-hamburger span {
    display: block; width: 24px; height: 2px; background: var(--ink);
    transition: transform 0.3s, opacity 0.3s;
  }
  .hv-hamburger.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
  .hv-hamburger.open span:nth-child(2) { opacity: 0; }
  .hv-hamburger.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

  /* Mobile Menu Drawer */
  .hv-mobile-menu {
    display: none; position: fixed; top: 68px; left: 0; right: 0;
    background: rgba(255,255,255,0.98); backdrop-filter: blur(12px);
    border-bottom: 1px solid var(--mid-grey); z-index: 99;
    flex-direction: column; padding: 1.5rem 1.5rem 2rem;
    transform: translateY(-10px); opacity: 0;
    transition: transform 0.3s ease, opacity 0.3s ease;
  }
  .hv-mobile-menu.open { display: flex; transform: translateY(0); opacity: 1; }
  .hv-mobile-menu a {
    text-decoration: none; font-size: 0.85rem; font-weight: 500;
    color: var(--text-grey); letter-spacing: 0.06em; text-transform: uppercase;
    padding: 0.85rem 0; border-bottom: 1px solid var(--light-grey); transition: color 0.2s;
  }
  .hv-mobile-menu a:last-child { border-bottom: none; }
  .hv-mobile-menu a:hover { color: var(--red); }
  .hv-mob-cta {
    margin-top: 1.25rem !important; background: var(--red); color: var(--white) !important;
    text-align: center; padding: 0.85rem 1.5rem !important; border-radius: 2px;
    font-weight: 600 !important; border: none !important;
  }

  /* ─── HERO ─── */
  .hv-hero {
    min-height: 100vh; display: grid; grid-template-columns: 1fr 1fr;
    padding-top: 68px; position: relative; overflow: hidden; background: var(--white);
  }
  .hv-hero-bg-shape {
    position: absolute; right: 0; top: 0; bottom: 0; width: 50%;
    background: var(--off-white); clip-path: polygon(8% 0%, 100% 0%, 100% 100%, 0% 100%); z-index: 0;
  }
  .hv-hero-left {
    position: relative; z-index: 1;
    display: flex; flex-direction: column; justify-content: center;
    padding: 5rem 4rem 5rem 5rem;
  }
  .hv-hero-pill {
    display: inline-flex; align-items: center; gap: 0.5rem;
    background: #FFF0F2; border: 1px solid #FFCDD4; color: var(--red);
    font-size: 0.72rem; font-weight: 600; letter-spacing: 0.1em; text-transform: uppercase;
    padding: 0.35rem 0.9rem; border-radius: 100px; margin-bottom: 2rem; width: fit-content;
  }
  .hv-hero-pill span {
    width: 6px; height: 6px; background: var(--red); border-radius: 50%;
    display: block; animation: hv-pulse 1.5s ease-in-out infinite;
  }
  // .hv-hero h1 {
  //   font-family: 'Syne', sans-serif; font-size: clamp(2.2rem, 5vw, 5rem); font-weight: 800;
  //   line-height: 1.02; letter-spacing: -0.04em; color: var(--black); margin-bottom: 1.5rem;
  // }

  .hv-hero h1 {
  font-family: 'Syne', sans-serif;
  font-size: clamp(2.0em, 4vw,5rem);
  font-weight: 500;        /* 👈 normal */
  line-height: 1.3;        /* 👈 readable */
  letter-spacing: normal;  /* 👈 spacing fix */
  color: var(--black);
  margin-bottom: 1.5rem;
}
  .hv-hero h1 .hv-red { color: var(--red); }
  .hv-hero-tagline {
    font-family: 'Syne', sans-serif; font-size: 1rem; font-weight: 700;
    color: var(--black); margin-bottom: 1.25rem;
    display: flex; align-items: center; gap: 0.6rem;
  }
  .hv-hero-tagline::before { content: ''; display: block; width: 28px; height: 2px; background: var(--red); flex-shrink: 0; }
  .hv-hero-desc { font-size: 1rem; color: var(--text-grey); line-height: 1.8; max-width: 460px; font-weight: 300; margin-bottom: 2.5rem; }
  .hv-hero-buttons { display: flex; gap: 1rem; flex-wrap: wrap; }
  .hv-btn-primary {
    display: inline-flex; align-items: center; gap: 0.6rem;
    background: var(--red); color: var(--white); padding: 0.9rem 2rem;
    font-size: 0.88rem; font-weight: 600; font-family: 'Syne', sans-serif;
    text-decoration: none; border-radius: 2px; letter-spacing: 0.02em;
    transition: background 0.2s, transform 0.15s;
  }
  .hv-btn-primary:hover { background: var(--red-dark); transform: translateY(-1px); }
  .hv-btn-outline {
    display: inline-flex; align-items: center; gap: 0.6rem;
    background: transparent; color: var(--black); padding: 0.9rem 2rem;
    font-size: 0.88rem; font-weight: 600; font-family: 'Syne', sans-serif;
    text-decoration: none; border-radius: 2px; border: 1.5px solid var(--black);
    letter-spacing: 0.02em; transition: border-color 0.2s, color 0.2s;
  }
  .hv-btn-outline:hover { border-color: var(--red); color: var(--red); }

  /* Hero Right */
  .hv-hero-right {
    position: relative; z-index: 1;
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    padding: 4rem 3rem; gap: 2rem;
  }
  .hv-hero-logo-box {
    background: var(--white); border-radius: 12px; padding: 3.5rem 5rem;
    box-shadow: 0 20px 80px rgba(0,0,0,0.1), 0 4px 16px rgba(0,0,0,0.06);
    display: flex; align-items: center; justify-content: center;
    width: 100%; max-width: 400px; animation: hv-float 5s ease-in-out infinite;
  }
  .hv-hero-logo-box img { width: 240px; height: auto; display: block; }
  .hv-hero-logo-text { font-family: 'Syne', sans-serif; font-size: 4rem; font-weight: 800; color: #111; }
  .hv-hero-logo-text span { color: #D0021B; }
  .hv-hero-stats-row {
    display: flex; gap: 0; width: 100%; max-width: 400px;
    border: 1px solid var(--mid-grey); border-radius: 4px; overflow: hidden; background: var(--white);
  }
  .hv-hero-stat { flex: 1; text-align: center; padding: 1.25rem 0.5rem; border-right: 1px solid var(--mid-grey); }
  .hv-hero-stat:last-child { border-right: none; }
  .hv-hero-stat-num { font-family: 'Syne', sans-serif; font-size: 1.5rem; font-weight: 800; color: var(--red); margin-bottom: 0.2rem; }
  .hv-hero-stat-label { font-size: 0.65rem; text-transform: uppercase; letter-spacing: 0.07em; color: var(--text-light); font-weight: 500; }

  /* ─── COMMON ─── */
  .hv-tag {
    display: inline-flex; align-items: center; gap: 0.6rem;
    font-size: 0.7rem; font-weight: 700; letter-spacing: 0.14em;
    text-transform: uppercase; color: var(--red); margin-bottom: 1.25rem;
  }
  .hv-tag::before { content: ''; display: block; width: 22px; height: 2px; background: var(--red); }
  // .hv-section-title {
  //   font-family: 'Syne', sans-serif; font-size: clamp(1.8rem, 3.5vw, 3.2rem); font-weight: 800;
  //   letter-spacing: -0.03em; color: var(--black); line-height: 1.1; margin-bottom: 1.25rem;
  // }
  .hv-section-title {
  font-family: 'Syne', sans-serif;
  font-size: clamp(1.8rem, 3.5vw, 3.2rem);
  font-weight: 500;        /* 👈 normal */
  letter-spacing: normal;  /* 👈 clean spacing */
  color: var(--black);
}
  .hv-section-title .hv-red { color: var(--red); }

  /* ─── STORY ─── */
  .hv-story { background: var(--black); color: var(--white); position: relative; overflow: hidden; padding: 7rem 5rem; }
  .hv-story-watermark {
    position: absolute; right: -1rem; top: 50%; transform: translateY(-50%);
    font-family: 'Syne', sans-serif; font-size: 13rem; font-weight: 800;
    color: rgba(255,255,255,0.03); letter-spacing: -0.05em; pointer-events: none;
  }
  .hv-story .hv-tag { color: var(--red); }
  .hv-story .hv-tag::before { background: var(--red); }
  .hv-story-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 6rem; align-items: start; }
  .hv-story .hv-section-title { color: var(--white); }
  .hv-story-body p { font-size: 0.97rem; line-height: 1.9; color: rgba(255,255,255,0.6); font-weight: 300; margin-bottom: 1.25rem; }
  .hv-story-highlight {
    border-left: 3px solid var(--red); padding: 1rem 1.5rem; margin: 2rem 0;
    background: rgba(208,2,27,0.08); border-radius: 0 4px 4px 0;
    font-family: 'Syne', sans-serif; font-size: 0.98rem; font-weight: 600;
    color: rgba(255,255,255,0.85); font-style: italic;
  }
  .hv-timeline { display: flex; flex-direction: column; }
  .hv-tl-item { display: flex; gap: 1.5rem; padding-bottom: 2.5rem; position: relative; }
  .hv-tl-item:not(:last-child)::after {
    content: ''; position: absolute; left: 17px; top: 36px; bottom: 0;
    width: 2px; background: linear-gradient(to bottom, var(--red), rgba(208,2,27,0.1));
  }
  .hv-tl-dot {
    width: 36px; height: 36px; border-radius: 50%; background: var(--red);
    display: flex; align-items: center; justify-content: center; font-size: 0.9rem; flex-shrink: 0;
  }
  .hv-tl-h3 { font-family: 'Syne', sans-serif; font-size: 1rem; font-weight: 700; color: var(--white); margin-bottom: 0.35rem; margin-top: 0.5rem; }
  .hv-tl-text p { font-size: 0.86rem; color: rgba(255,255,255,0.5); line-height: 1.65; margin: 0; }

  /* ─── USP ─── */
  .hv-usp { background: var(--white); padding: 7rem 5rem; }
  .hv-usp-intro { display: grid; grid-template-columns: 1fr 1fr; gap: 4rem; margin-bottom: 4rem; align-items: end; }
  .hv-usp-sub { font-size: 0.97rem; color: var(--text-grey); line-height: 1.8; font-weight: 300; }
  .hv-usp-cards {
    display: grid; grid-template-columns: repeat(3, 1fr);
    gap: 1.5px; background: var(--mid-grey); border: 1.5px solid var(--mid-grey); border-radius: 4px; overflow: hidden;
  }
  .hv-usp-card { background: var(--white); padding: 2.5rem 2rem; position: relative; overflow: hidden; transition: background 0.25s; }
  .hv-usp-card:hover { background: var(--off-white); }
  .hv-usp-card-num {
    font-family: 'Syne', sans-serif; font-size: 5rem; font-weight: 800;
    color: var(--light-grey); position: absolute; top: -1rem; right: 1rem;
    line-height: 1; letter-spacing: -0.05em; transition: color 0.25s;
  }
  .hv-usp-card:hover .hv-usp-card-num { color: #FFCDD4; }
  .hv-usp-icon { font-size: 2rem; margin-bottom: 1.25rem; display: block; }
  .hv-usp-card h3 { font-family: 'Syne', sans-serif; font-size: 1.1rem; font-weight: 700; color: var(--black); margin-bottom: 0.7rem; }
  .hv-usp-card p { font-size: 0.86rem; color: var(--text-grey); line-height: 1.7; font-weight: 300; }
  .hv-red-bar { position: absolute; bottom: 0; left: 0; height: 3px; width: 0; background: var(--red); transition: width 0.4s ease; }
  .hv-usp-card:hover .hv-red-bar { width: 100%; }

  /* ─── WHY ─── */
  .hv-why-section { padding: 0 5rem 7rem; background: var(--white); }
  .hv-why-grid {
    display: grid; grid-template-columns: 1fr 1fr;
    overflow: hidden; border: 1.5px solid var(--mid-grey); border-radius: 4px;
  }
  .hv-why-col { padding: 4rem; }
  .hv-why-col:first-child { border-right: 1.5px solid var(--mid-grey); background: var(--white); }
  .hv-why-col:last-child { background: var(--black); }
  .hv-why-col:last-child .hv-tag { color: var(--red); }
  .hv-why-col:last-child .hv-tag::before { background: var(--red); }
  // .hv-why-col h2 { font-family: 'Syne', sans-serif; font-size: clamp(1.2rem, 2vw, 1.8rem); font-weight: 800; letter-spacing: -0.03em; color: var(--black); margin-bottom: 2.5rem; line-height: 1.2; }

  .hv-why-col h2 {
  font-family: 'Syne', sans-serif;
  font-size: clamp(1.2rem, 2vw, 1.8rem);
  font-weight: 500;        /* 👈 normal */
  letter-spacing: normal;  /* 👈 clean spacing */
  color: var(--black);
}
  .hv-why-col:last-child h2 { color: var(--white); }
  .hv-why-list { list-style: none; display: flex; flex-direction: column; gap: 1.1rem; }
  .hv-why-list li { display: flex; gap: 1rem; align-items: flex-start; font-size: 0.92rem; color: var(--ink); line-height: 1.6; }
  .hv-why-col:last-child .hv-why-list li { color: rgba(255,255,255,0.72); }
  .hv-why-check {
    width: 20px; height: 20px; background: var(--red); border-radius: 50%;
    display: flex; align-items: center; justify-content: center; font-size: 0.6rem;
    color: var(--white); font-weight: 700; flex-shrink: 0; margin-top: 0.1rem;
  }

  /* ─── NAME ─── */
  .hv-name-section {
    background: var(--red); color: var(--white); padding: 8rem 5rem;
    position: relative; overflow: hidden; text-align: center;
  }
  .hv-name-bg-text {
    position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);
    font-family: 'Syne', sans-serif; font-size: 18rem; font-weight: 800;
    color: rgba(255,255,255,0.05); letter-spacing: -0.05em; white-space: nowrap; pointer-events: none;
  }
  .hv-name-section .hv-tag { color: rgba(255,255,255,0.7); justify-content: center; }
  .hv-name-section .hv-tag::before { background: rgba(255,255,255,0.5); }
  // .hv-name-section h2 {
  //   font-family: 'Syne', sans-serif; font-size: clamp(2rem, 5vw, 5rem); font-weight: 800;
  //   letter-spacing: -0.04em; color: var(--white); line-height: 1.05; margin-bottom: 1.5rem;
  // }
.hv-name-section h2 {
  font-family: 'Syne', sans-serif;
  font-size: clamp(2rem, 5vw, 5rem);
  font-weight: 500;        /* 👈 normal */
  letter-spacing: normal;  /* 👈 clean spacing */
  color: var(--white);
  line-height: 1.3;        /* 👈 readable */
  margin-bottom: 1.5rem;
}

  .hv-name-section p { font-size: 1.1rem; color: rgba(255,255,255,0.75); line-height: 1.8; font-weight: 300; max-width: 600px; margin: 0 auto 2.5rem; }
  .hv-tagline-badge {
    display: inline-flex; align-items: center; gap: 0.75rem;
    background: var(--white); color: var(--red); padding: 0.8rem 2.5rem; border-radius: 100px;
    font-family: 'Syne', sans-serif; font-size: 1.1rem; font-weight: 700;
    box-shadow: 0 8px 32px rgba(0,0,0,0.15);
  }

  /* ─── HYGIENE ─── */
  .hv-hygiene { background: var(--off-white); border-top: 1px solid var(--mid-grey); padding: 7rem 5rem; }
  .hv-hygiene-grid { display: grid; grid-template-columns: 1.1fr 1fr; gap: 6rem; align-items: center; }
  .hv-hygiene-text p { font-size: 0.97rem; line-height: 1.8; color: var(--text-grey); font-weight: 300; margin-bottom: 2rem; }
  .hv-hygiene-chips { display: flex; flex-wrap: wrap; gap: 0.75rem; }
  .hv-hygiene-chip {
    display: flex; align-items: center; gap: 0.4rem; padding: 0.45rem 1rem; border-radius: 100px;
    font-size: 0.78rem; font-weight: 500; border: 1.5px solid var(--mid-grey); background: var(--white); color: var(--ink);
  }
  .hv-hygiene-cards { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; }
  .hv-h-card {
    background: var(--white); border: 1px solid var(--mid-grey); border-radius: 6px; padding: 1.75rem 1.5rem;
    transition: border-color 0.2s, transform 0.2s;
  }
  .hv-h-card:hover { border-color: var(--red); transform: translateY(-3px); }
  .hv-h-card:first-child { grid-column: span 2; background: var(--black); border-color: var(--black); }
  .hv-h-icon { font-size: 1.8rem; margin-bottom: 0.75rem; display: block; }
  .hv-h3-sm { font-family: 'Syne', sans-serif; font-size: 0.95rem; font-weight: 700; color: var(--black); margin-bottom: 0.3rem; }
  .hv-h-card:first-child .hv-h3-sm { color: var(--white); }
  .hv-h-card p { font-size: 0.8rem; color: var(--text-grey); line-height: 1.6; }
  .hv-h-card:first-child p { color: rgba(255,255,255,0.55); }

  /* ─── FOOTER ─── */
  .hv-footer {
    background: var(--ink); color: rgba(255,255,255,0.4); text-align: center;
    padding: 2.5rem; font-size: 0.78rem; display: flex; flex-direction: column; align-items: center; gap: 1rem;
  }
  .hv-footer img { height: 26px; opacity: 0.5; }
  .hv-footer-logo-text { font-family: 'Syne', sans-serif; font-size: 1.4rem; font-weight: 800; color: rgba(255,255,255,0.25); }
  .hv-footer-logo-text span { color: rgba(208,2,27,0.5); }
  .hv-footer em { color: rgba(255,255,255,0.35); font-style: italic; }

  /* ─── ANIMATIONS ─── */
  @keyframes hv-float { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
  @keyframes hv-pulse { 0%,100% { opacity:1; transform:scale(1); } 50% { opacity:0.5; transform:scale(0.8); } }
  .hv-fade-up { opacity: 0; transform: translateY(28px); transition: opacity 0.65s ease, transform 0.65s ease; }
  .hv-fade-up.visible { opacity: 1; transform: translateY(0); }

  /* ═══════════════════════════════════════════
     MOBILE — max 768px
  ═══════════════════════════════════════════ */
  @media (max-width: 768px) {
    /* Nav */
    .hv-nav { padding: 0 1.25rem; }
    .hv-nav-links { display: none; }
    .hv-hamburger { display: flex; }

    /* Hero */
    .hv-hero { grid-template-columns: 1fr; min-height: auto; padding-top: 68px; }
    .hv-hero-bg-shape { display: none; }
    .hv-hero-right { display: none; }
    .hv-hero-left { padding: 3rem 1.25rem 4rem; }
    .hv-hero h1 { font-size: clamp(1.9rem, 8vw, 2.6rem); }
    .hv-hero-desc { font-size: 0.95rem; max-width: 100%; }
    .hv-hero-buttons { flex-direction: column; }
    .hv-btn-primary, .hv-btn-outline { justify-content: center; width: 100%; text-align: center; }

    /* Story */
    .hv-story { padding: 4rem 1.25rem; }
    .hv-story-watermark { font-size: 5rem; }
    .hv-story-grid { grid-template-columns: 1fr; gap: 3rem; }

    /* USP */
    .hv-usp { padding: 4rem 1.25rem; }
    .hv-usp-intro { grid-template-columns: 1fr; gap: 1.5rem; margin-bottom: 2.5rem; }
    .hv-usp-cards { grid-template-columns: 1fr; }

    /* Why */
    .hv-why-section { padding: 0 1.25rem 4rem; }
    .hv-why-grid { grid-template-columns: 1fr; }
    .hv-why-col:first-child { border-right: none; border-bottom: 1.5px solid var(--mid-grey); }
    .hv-why-col { padding: 2.5rem 1.5rem; }

    /* Name */
    .hv-name-section { padding: 5rem 1.25rem; }
    .hv-name-bg-text { font-size: 4rem; }
    .hv-name-section p { font-size: 0.97rem; }
    .hv-tagline-badge { font-size: 0.9rem; padding: 0.7rem 1.5rem; }

    /* Hygiene */
    .hv-hygiene { padding: 4rem 1.25rem; }
    .hv-hygiene-grid { grid-template-columns: 1fr; gap: 3rem; }
    .hv-hygiene-cards { grid-template-columns: 1fr; }
    .hv-h-card:first-child { grid-column: span 1; }

    /* Footer */
    .hv-footer { padding: 2rem 1.25rem; }
  }

  /* ═══════════════════════════════════════════
     TABLET — 769px to 1024px
  ═══════════════════════════════════════════ */
  @media (min-width: 769px) and (max-width: 1024px) {
    .hv-nav { padding: 0 2rem; }
    .hv-nav-links { gap: 1.5rem; }
    .hv-nav-links a { font-size: 0.72rem; }

    .hv-hero-left { padding: 4rem 2rem 4rem 3rem; }
    .hv-hero h1 { font-size: clamp(2rem, 4vw, 3.5rem); }

    .hv-story { padding: 5rem 3rem; }
    .hv-story-grid { gap: 3.5rem; }

    .hv-usp { padding: 5rem 3rem; }
    .hv-usp-intro { gap: 2.5rem; }

    .hv-why-section { padding: 0 3rem 5rem; }
    .hv-why-col { padding: 3rem 2.5rem; }

    .hv-name-section { padding: 6rem 3rem; }
    .hv-name-bg-text { font-size: 10rem; }

    .hv-hygiene { padding: 5rem 3rem; }
    .hv-hygiene-grid { gap: 3.5rem; }
  }
`;

export default function HavbitAbout() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const styleEl = document.createElement("style");
    styleEl.textContent = styles;
    document.head.appendChild(styleEl);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("visible");
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll(".hv-fade-up").forEach((el) => observer.observe(el));

    return () => {
      document.head.removeChild(styleEl);
      observer.disconnect();
    };
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      {/* SKIP NAV */}
      <a
        href="#main-content"
        style={{ position: "absolute", left: "-9999px", top: "auto", width: "1px", height: "1px", overflow: "hidden" }}
        tabIndex={0}
      >
        Skip to main content
      </a>

      {/* ─── HEADER ─── */}
      <header className="hv-header" role="banner">
        <nav className="hv-nav" aria-label="Main navigation">
          {/* Logo */}
          {/* <div className="hv-nav-logo">
            <a href="https://www.havbit.com" aria-label="Havbit - Go to homepage">
              <img
                src="/assets/havbit.png"
                alt="Havbit Online Food Marketplace Logo"
                width={120}
                height={32}
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextElementSibling.style.display = "block";
                }}
              />
              <div className="hv-nav-logo-text" style={{ display: "none" }}>
                hav<span>bit</span>
              </div>
            </a>
          </div> */}

  

<div className="hv-nav-logo">
  <Link to="/" aria-label="Havbit - Go to homepage">
    <img
      src={logo}
      alt="Havbit Logo"
      style={{ height: "90px", width: "auto" }}
    />
  </Link>
</div>

          {/* Desktop Links */}
          <ul className="hv-nav-links" role="list">
            <li><a href="#story">Our Story</a></li>
            <li><a href="#usp">Why Havbit</a></li>
            <li><a href="#list">For Buyers</a></li>
            <li><a href="#sell">For Brands</a></li>
            <li><a href="#hygiene">Food Safety</a></li>
            <li>
              <a href="#list" className="hv-nav-cta" aria-label="Start exploring food brands on Havbit">
                Explore Now
              </a>
            </li>
          </ul>

          {/* Hamburger Button */}
          <button
            className={`hv-hamburger${menuOpen ? " open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </nav>

        {/* Mobile Drawer */}
        <div
          className={`hv-mobile-menu${menuOpen ? " open" : ""}`}
          role="navigation"
          aria-label="Mobile navigation"
        >
          <a href="#story" onClick={closeMenu}>Our Story</a>
          <a href="#usp" onClick={closeMenu}>Why Havbit</a>
          <a href="#list" onClick={closeMenu}>For Buyers</a>
          <a href="#sell" onClick={closeMenu}>For Brands</a>
          <a href="#hygiene" onClick={closeMenu}>Food Safety</a>
          <a href="#list" className="hv-mob-cta" onClick={closeMenu}>Explore Now →</a>
        </div>
      </header>

      <main id="main-content">

        {/* ─── HERO ─── */}
        <section className="hv-hero" aria-labelledby="hero-heading">
          <div className="hv-hero-bg-shape"></div>
          <div className="hv-hero-left">
            <div className="hv-hero-pill">
              <span></span> Online Food Marketplace
            </div>
            <h1 id="hero-heading">
              Discover great food —{" "}
              <span className="hv-red">all in one</span> place with Havbit, India's online food marketplace.
            </h1>
            <div className="hv-hero-tagline">Have a Bite from Havbit</div>
            <p className="hv-hero-desc">
              Havbit is an emerging online food marketplace designed to help customers discover and buy food products from multiple brands — all in one place.
            </p>
            <div className="hv-hero-buttons">
              {/* <a href="#list" className="hv-btn-primary">
                Shop Now
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a> */}
<Link to="/" className="hv-btn-primary">
  Shop Now
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
</Link>

              {/* <a href="#sell" className="hv-btn-outline">List Your Brand →</a> */}
              <a href="https://seller.havbit.in" 
   target="_blank" 
   rel="noopener noreferrer" 
   className="hv-btn-outline">
  List Your Brand 
</a>
            </div>
          </div>
          <div className="hv-hero-right">
            <div className="hv-hero-logo-box">
              <img
                src="/assets/havbit.png"
                alt="Havbit - Online Food Marketplace Logo"
                width={240}
                height={80}
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextElementSibling.style.display = "block";
                }}
              />
              <div className="hv-hero-logo-text" style={{ display: "none" }}>
                hav<span>bit</span>
              </div>
            </div>
            <div className="hv-hero-stats-row">
              <div className="hv-hero-stat">
                <div className="hv-hero-stat-num">Multi</div>
                <div className="hv-hero-stat-label">Brand</div>
              </div>
              <div className="hv-hero-stat">
                <div className="hv-hero-stat-num">1</div>
                <div className="hv-hero-stat-label">Platform</div>
              </div>
              <div className="hv-hero-stat">
                <div className="hv-hero-stat-num">∞</div>
                <div className="hv-hero-stat-label">Choices</div>
              </div>
            </div>
          </div>
        </section>

        {/* ─── STORY ─── */}
        <section className="hv-story" id="story" aria-labelledby="story-heading">
          <div className="hv-story-watermark">STORY</div>
          <div className="hv-story-grid">
            <div className="hv-story-body hv-fade-up">
              <div className="hv-tag">The Havbit Story</div>
              <h2 className="hv-section-title" id="story-heading">
                Bridging the gap between{" "}
                <span className="hv-red">food lovers</span> and brands
              </h2>
              <p>
                In today's digital world, food lovers often struggle to find quality food products across different websites and platforms. Many food brands also face challenges reaching new customers without spending heavily on advertising.
              </p>
              <div className="hv-story-highlight">
                "Havbit bridges this gap — a centralized food marketplace where customers and food brands connect easily."
              </div>
              <p>
                Instead of managing inventory, Havbit operates as a multi-brand food marketplace. Brands list their products and fulfill orders directly from their own warehouses.
              </p>
              <p>
                This model allows Havbit to offer customers a diverse selection — packaged foods, regional specialties, healthy options, snacks, beverages, and gourmet items.
              </p>
            </div>
            <div className="hv-timeline hv-fade-up">
              {[
                { dot: "🔍", title: "The Problem We Saw", text: "Food lovers couldn't find quality products in one place. Brands struggled to reach customers affordably." },
                { dot: "💡", title: "The Idea", text: "A centralized marketplace with zero inventory burden — brands ship direct, customers get more choice." },
                { dot: "🚀", title: "Havbit Is Born", text: "An emerging multi-brand food platform where discovery meets convenience at scale." },
                { dot: "🌱", title: "Growing Together", text: "Building a community of food brands and food lovers, one bite at a time." },
              ].map((item, i) => (
                <div className="hv-tl-item" key={i}>
                  <div className="hv-tl-dot">{item.dot}</div>
                  <div className="hv-tl-text">
                    <h3 className="hv-tl-h3">{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ─── USP ─── */}
        <section className="hv-usp" id="usp" aria-labelledby="usp-heading">
          <div className="hv-usp-intro">
            <div className="hv-fade-up">
              <div className="hv-tag">Our USP</div>
              <h2 className="hv-section-title" id="usp-heading">
                What makes <span className="hv-red">Havbit</span> different from other food marketplaces?
              </h2>
            </div>
            <p className="hv-usp-sub hv-fade-up">
              We're not just another food delivery app. Havbit is a discovery-first marketplace built around how food brands actually work — and how food lovers actually shop.
            </p>
          </div>
          <div className="hv-usp-cards hv-fade-up">
            {[
              { num: "01", icon: "🗺️", title: "Multi-Brand Discovery", text: "Explore packaged foods, regional specialties, healthy snacks, beverages and gourmet items from multiple brands under one roof." },
              { num: "02", icon: "📦", title: "Zero Inventory Model", text: "Brands ship directly from their own warehouses, keeping products fresh and operations lean — no middle storage, no markup chain." },
              { num: "03", icon: "🤝", title: "Brands & Buyers Connected", text: "We bridge the gap between food lovers and brands with technology that makes discovery effortless and selling scalable." },
            ].map((card, i) => (
              <div className="hv-usp-card" key={i}>
                <span className="hv-usp-card-num">{card.num}</span>
                <span className="hv-usp-icon">{card.icon}</span>
                <h3>{card.title}</h3>
                <p>{card.text}</p>
                <div className="hv-red-bar"></div>
              </div>
            ))}
          </div>
        </section>

        {/* ─── WHY LIST / SELL ─── */}
        <section className="hv-why-section" aria-label="Why choose Havbit — for buyers and brands">
          <div className="hv-why-grid hv-fade-up" id="list">
            <div className="hv-why-col">
              <div className="hv-tag">For Customers</div>
              <h2>Why Buy Food Online on Havbit?</h2>
              <ul className="hv-why-list" aria-label="Benefits of shopping on Havbit">
                {[
                  "Discover hundreds of food brands in one curated marketplace",
                  "Access regional specialties and niche products unavailable elsewhere",
                  "Explore diverse categories — healthy, gourmet, snacks, beverages & more",
                  "Convenient, centralized shopping with trusted brand listings",
                  "Discover new brands you'd never find through traditional retail",
                ].map((item, i) => (
                  <li key={i}><span className="hv-why-check">✓</span> {item}</li>
                ))}
              </ul>
            </div>
            <div className="hv-why-col" id="sell">
              <div className="hv-tag">For Brands</div>
              <h2>Why Sell Your Food Brand on Havbit?</h2>
              <ul className="hv-why-list" aria-label="Benefits of selling on Havbit for food brands">
                {[
                  "Reach a growing base of food-conscious customers without heavy ad spend",
                  "No inventory management — you ship from your own warehouse",
                  "List alongside complementary brands for wider visibility",
                  "Build brand awareness through a trusted discovery platform",
                  "Simple onboarding with dedicated brand support",
                ].map((item, i) => (
                  <li key={i}><span className="hv-why-check">✓</span> {item}</li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        {/* ─── NAME ─── */}
        <section className="hv-name-section" aria-labelledby="name-heading">
          <div className="hv-name-bg-text">havbit</div>
          <div className="hv-tag hv-fade-up">The Name</div>
          <h2 className="hv-fade-up" id="name-heading">
            Why is it called 'Havbit'? The Story Behind the Name
          </h2>
          <p className="hv-fade-up">
            A name that reflects what we believe — that great food isn't a luxury or a rare occasion. It's a daily habit.{" "}
            <em>Havbit</em> is about building the habit of discovering, enjoying, and celebrating food every single day.
          </p>
          <div className="hv-tagline-badge hv-fade-up">🍴 Have a Bite from Havbit</div>
        </section>

        {/* ─── HYGIENE ─── */}
        <section className="hv-hygiene" id="hygiene" aria-labelledby="hygiene-heading">
          <div className="hv-hygiene-grid">
            <div className="hv-hygiene-text hv-fade-up">
              <div className="hv-tag">Hygiene & Food Safety</div>
              <h2 className="hv-section-title" id="hygiene-heading">
                We take food safety as seriously{" "}
                <span className="hv-red">as you do.</span>
              </h2>
              <p>
                Every brand that lists on Havbit is vetted for food safety compliance and quality standards. We believe great food starts with responsible practices — from the kitchen to your doorstep.
              </p>
              <div className="hv-hygiene-chips">
                {["✅ Quality Vetted Brands", "🧼 Hygiene Compliance", "📋 Safety Standards", "📦 Tamper-Proof Packaging", "🌡️ Cold Chain Assurance"].map((chip, i) => (
                  <div className="hv-hygiene-chip" key={i}>{chip}</div>
                ))}
              </div>
            </div>
            <div className="hv-hygiene-cards hv-fade-up">
              {[
                { icon: "🏅", title: "Certified Brand Partners", text: "All brands on Havbit meet food safety and hygiene benchmarks before going live on the platform." },
                { icon: "🌡️", title: "Cold Chain", text: "Temperature-sensitive products handled with care throughout fulfillment." },
                { icon: "🔍", title: "Transparency", text: "Full ingredient info so you know exactly what you're getting." },
              ].map((card, i) => (
                <div className="hv-h-card" key={i}>
                  <span className="hv-h-icon">{card.icon}</span>
                  <h3 className="hv-h3-sm">{card.title}</h3>
                  <p>{card.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

      </main>

      {/* ─── FOOTER ─── */}
      {/* <footer className="hv-footer" role="contentinfo" aria-label="Havbit footer">
        <img
          src="/assets/havbit.png"
          alt="Havbit Food Marketplace"
          width={100}
          height={26}
          loading="lazy"
          onError={(e) => {
            e.target.style.display = "none";
            e.target.nextElementSibling.style.display = "block";
          }}
        />
        <div className="hv-footer-logo-text" style={{ display: "none" }}>
          hav<span>bit</span>
        </div>
        <p>© 2025 Havbit. All rights reserved. · Building India's food discovery marketplace.</p>
        <p><em>Have a Bite from Havbit 🍴</em></p>
      </footer> */}
    </>
  );
}